import React, { useState, useRef, useEffect } from 'react';
import FavoriteModule from '../../../components/settings/FavoriteModule/Index';
import QrReader from '../../../GeneralComponents/QrReader/QrReader';

function navigateToCreate(formato, customViewId, surveyParentId, surveyParentToken) {
  let url;
  if (surveyParentId && parseInt(surveyParentId) > 0 && surveyParentToken) {
    url = `${window.location.origin}/formatos/generate_questions_surveys/${formato.token}/${surveyParentToken}/parent`;
  } else {
    const cvId = customViewId && parseInt(customViewId) > 0 ? customViewId : 0;
    url = `${window.location.origin}/formatos/generate_questions/${formato.token}/0/${cvId}`;
  }
  Turbolinks.visit(url, '_self');
}

export { navigateToCreate };

// ===== Reusable dropdown =====
function ToolbarDropdown({ label, icon, children, title }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="cm-options-dropdown" ref={ref}>
      <button className="cm-btn cm-btn--sm" onClick={() => setOpen(!open)} title={title || label}>
        {icon && <i className={icon} />}{label ? ` ${label}` : ''}
      </button>
      {open && (
        <div className="cm-options-dropdown__menu">
          {typeof children === 'function' ? children(() => setOpen(false)) : children}
        </div>
      )}
    </div>
  );
}

// ===== Page Header =====
export function RecordsBreadcrumb({ formato, format_category, breadcrumb, custom_view_name }) {
  const crumbs = breadcrumb || [];
  const hasCustomView = !!(custom_view_name && custom_view_name.length > 0);

  return (
    <div className="cm-breadcrumb">
      {crumbs.map((cat, i) => (
        <React.Fragment key={cat.token}>
          {i > 0 && <span className="cm-breadcrumb__sep">›</span>}
          <a
            href={`/formatos/format_categories/${cat.token}`}
            className="cm-breadcrumb__item"
            data-turbolinks="true"
          >
            {cat.name}
          </a>
        </React.Fragment>
      ))}
      <span className="cm-breadcrumb__sep">›</span>
      <span className="cm-breadcrumb__item cm-breadcrumb__item--active">
        {hasCustomView ? custom_view_name : formato.name}
      </span>
    </div>
  );
}

export function RecordsPageHeader({ formato, format_category, estados, custom_view_id, custom_view_name, survey_parent_id, survey_parent_token, count_registers, current_plan, tenant, onShowUpgradePlan }) {
  // Titulo principal: nombre de la vista personalizada si aplica, si no el del formato.
  // Cuando hay vista personalizada, mostramos el nombre del formato como subtitulo
  // para no perder el contexto de que es una vista sobre "Empleados", por ejemplo.
  const titleMain = custom_view_name && custom_view_name.length > 0 ? custom_view_name : formato.name;
  const isCustomView = !!(custom_view_name && custom_view_name.length > 0);
  const currentUrl = window.location.pathname;

  const handleCreate = () => {
    if (current_plan && count_registers >= current_plan.records_plan) {
      if (onShowUpgradePlan) onShowUpgradePlan();
      return;
    }
    navigateToCreate(formato, custom_view_id, survey_parent_id, survey_parent_token);
  };

  return (
    <div className="app-page-title" style={{ padding: '10px 20px', minHeight: 'auto' }}>
      <div className="page-title-wrapper">
        <div className="page-title-heading ui-modules" style={{ margin: 0 }}>
          <div className="page-title-icon">
            <i className="fas fa-file-alt icon-gradient bg-mean-fruit" />
          </div>
          <div className="ui-header-title__container_title_subtitle">
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span className="ui-header-title__space_title">{titleMain}</span>
              <FavoriteModule
                url={currentUrl}
                name={titleMain}
                icon="fas fa-file-alt"
              />
            </div>
            <div className="page-title-subheading" style={{ fontSize: 11 }}>
              {isCustomView ? <>Vista personalizada de <strong>{formato.name}</strong></> : 'Registros'}
            </div>
          </div>
        </div>

        <div className="page-title-actions">
          {estados.create && (
            <button className="cm-btn-create" onClick={handleCreate}>
              <i className="fas fa-file" /> Crear registro
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ===== Inline Toolbar =====
export default function RecordsInlineToolbar({
  formato, format_category, estados, selectedIds,
  count_registers,
  showFilters, onToggleFilters, onClearFilters, onCancelFilters,
  columns, searchText, searchColumn, onSearchTextChange, onSearchColumnChange, onSearch,
  domain, tenant, format_pdfs, format_custom_view_dashboard,
  configuration_format, custom_view_id, survey_parent_id,
  onCopyLink, onShowQr, onExportExcel, onShowUploadModal,
  onSendPdf, onDownloadPdf, view, showColumnOptions, onToggleColumnOptions,
  format_calendar_enabled, viewMode, onToggleView,
  matrix_reports, onMatrixReport
}) {
  const fcToken = format_category.token;
  const recordsBaseUrl = `/formatos/records/${formato.id}`;
  const editorUrl = `/formatos/format_categories/${fcToken}/formats/${formato.token}`;

  const showShare = tenant && tenant.tenant_state !== 'beewoker' && estados.shareFormat && estados.share_link;
  const showStats = format_custom_view_dashboard && format_custom_view_dashboard.length >= 1;
  const showImportExport = estados.exportFormat || estados.importFormat || estados.downloadTemplateFormat || (format_pdfs && format_pdfs.length > 0) || (matrix_reports && matrix_reports.length > 0);

  return (
    <div className="cm-toolbar">
      <div className="cm-toolbar__left">
        <div className="cm-search">
          <select
            className="cm-search__select"
            value={searchColumn}
            onChange={(e) => onSearchColumnChange(e.target.value)}
          >
            <option value="">Todas</option>
            {(columns || []).map(col => (
              <option key={col.id} value={col.id}>{col.name}</option>
            ))}
          </select>
          <div className="cm-search__input-wrap">
            <input
              type="text"
              className="cm-search__input"
              placeholder="Buscar..."
              value={searchText}
              onChange={(e) => onSearchTextChange(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            />
            {searchText && (
              <button className="cm-search__clear" onClick={() => { onSearchTextChange(''); onSearch(''); }}>
                <i className="fas fa-times" />
              </button>
            )}
          </div>
          <button className="cm-search__btn" onClick={onSearch}>
            <i className="fas fa-search" />
          </button>
        </div>

        <span className="cm-toolbar__info">{count_registers} registros</span>

        {selectedIds.length > 0 && (
          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--cm-primary)' }}>
            {selectedIds.length} seleccionados
          </span>
        )}
      </div>

      <div className="cm-toolbar__right">
        {/* Statistics dropdown */}
        {showStats && (
          <ToolbarDropdown label="Estadísticas" icon="fas fa-chart-bar">
            {(close) => (
              <>
                {format_custom_view_dashboard.map(d => (
                  <a
                    key={d.id}
                    className="cm-options-dropdown__item"
                    href={`/formatos/custom_dashboard/${d.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={close}
                  >
                    <i className="fas fa-chart-pie" /> {d.name}
                  </a>
                ))}
              </>
            )}
          </ToolbarDropdown>
        )}

        <button
          className={`cm-btn cm-btn--sm${showFilters ? ' cm-btn--primary' : ''}`}
          onClick={onToggleFilters}
          title="Filtros avanzados"
        >
          <i className="fas fa-filter" />
        </button>

        {/* Import/Export dropdown */}
        {showImportExport && (
          <ToolbarDropdown label="Importar/Exportar" icon="fas fa-file-excel">
            {(close) => (
              <>
                {estados.downloadTemplateFormat && (
                  <a
                    className="cm-options-dropdown__item"
                    href={`/formatos/format_categories/${format_category.id}/formats/${formato.id}/get_surveys_index_excel_template.xlsx`}
                  >
                    <i className="fas fa-download" /> Descargar plantilla
                  </a>
                )}
                {estados.importFormat && (
                  <button className="cm-options-dropdown__item" onClick={() => { onShowUploadModal(); close(); }}>
                    <i className="fas fa-upload" /> Importar desde Excel
                  </button>
                )}
                {estados.exportFormat && (
                  <button className="cm-options-dropdown__item" onClick={() => { onExportExcel(); close(); }}>
                    <i className="fas fa-file-export" /> Exportar datos
                  </button>
                )}
                {format_pdfs && format_pdfs.length > 0 && (
                  <>
                    <div className="cm-options-dropdown__divider" />
                    {format_pdfs.map(pdf => (
                      <button
                        key={`gen-${pdf.id}`}
                        className="cm-options-dropdown__item"
                        onClick={() => { onSendPdf(pdf); close(); }}
                      >
                        <i className="fas fa-file-pdf" /> Generar PDF {pdf.name}
                      </button>
                    ))}
                  </>
                )}
                {matrix_reports && matrix_reports.length > 0 && (
                  <>
                    <div className="cm-options-dropdown__divider" />
                    {matrix_reports.map(report => (
                      <button
                        key={`mr-${report.id}`}
                        className="cm-options-dropdown__item"
                        onClick={() => { onMatrixReport(report); close(); }}
                      >
                        <i className="fas fa-table" /> {report.name}
                      </button>
                    ))}
                  </>
                )}
              </>
            )}
          </ToolbarDropdown>
        )}

        {showFilters && (
          <button className="cm-btn cm-btn--sm cm-btn--danger-soft" onClick={onCancelFilters}>
            Cancelar
          </button>
        )}

        {/* Options / Views dropdown */}
        <ToolbarDropdown label="Opciones" icon="fas fa-ellipsis-h">
          {(close) => (
            <>
              {showShare && (
                <>
                  <button className="cm-options-dropdown__item" onClick={() => { onCopyLink(); close(); }}>
                    <i className="fas fa-link" /> Copiar Link
                  </button>
                  <button className="cm-options-dropdown__item" onClick={() => { onShowQr(); close(); }}>
                    <i className="fas fa-qrcode" /> Código QR
                  </button>
                  <div className="cm-options-dropdown__divider" />
                </>
              )}

              <QrReader
                format_id={formato.id}
                className="cm-options-dropdown__item"
              />

              <button className="cm-options-dropdown__item" onClick={() => { onToggleColumnOptions(); close(); }}>
                <i className={`fas fa-columns`} /> {showColumnOptions ? 'Ocultar opciones columnas' : 'Opciones de columnas'}
              </button>

              <a className="cm-options-dropdown__item" href={editorUrl} data-turbolinks="true" onClick={close}>
                <i className="fas fa-edit" /> Editor Formatos
              </a>

            </>
          )}
        </ToolbarDropdown>

        {format_calendar_enabled && onToggleView && (
          <button
            className={`cm-btn cm-btn--sm${viewMode === 'calendar' ? ' cm-btn--primary' : ''}`}
            onClick={onToggleView}
            title={viewMode === 'calendar' ? 'Ver lista' : 'Ver calendario'}
          >
            <i
              className={viewMode === 'calendar' ? 'fas fa-list' : 'fas fa-calendar-alt'}
              style={viewMode === 'calendar' ? { color: '#fff' } : undefined}
            />
          </button>
        )}
      </div>
    </div>
  );
}
